<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('prescriptions')"
      :columns="columns"
      :column_search="true"
      :extra_data="{ patient_uuid: $route.params.patient_uuid }"
      resource_url="/patient/prescription/datatables"
      :is_container="false"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
    <prescription-modal ref="prescription_modal" @success="refresh" />
    <!-- <atentions-modal ref="atentions_modal" @refresh="refresh" /> -->
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import PrescriptionModal from "./prescription_modal/Index.vue";
// import AtentionsModal from "../../atentions_modal/Index.vue";

import {
  get,
  error_message,
  format_date_time,
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
} from "@/utils";

export default {
  name: "Prescriptions",
  components: {
    GenericTable,
    PrescriptionModal,
    // AtentionsModal,
  },
  data() {
    let v = this;
    return {
      appointments: [],
      columns: [
        {
          title: v.$t("date"),
          searchable: true,
          // width: "60%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_date_time(row.start_date);
          },
        },
        {
          title: v.$t("doctor"),
          searchable: false,
          // width: "60%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.doctor_team_member ? row.doctor_team_member.name : "";
          },
        },
        {
          title: v.$t("prescription"),
          searchable: false,
          // width: "60%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.settings ? row.settings.details : "";
          },
        },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.prescription_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("print"),
                icon: "fa fa-print",
                icon_class: "is-small",
                click: function (e) {
                  console.log("print", e.detail.uuid);
                  // v.$refs.atentions_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete prescription?"),
                    v,
                    () => {
                      del("/patient/prescription", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_date_time,
    refresh() {
      let v = this;
      // Lógica para obtener las citas del paciente
      // get("/patient/appointment/list", { uuid: v.$route.params.patient_uuid })
      //   .then((appointments) => {
      //     v.appointments = appointments;
      //   })
      //   .catch((error) => {
      //     error_message(error);
      // });

      v.$refs.datatable.refresh();
    },
    create() {
      let v = this;
      v.$refs.prescription_modal.show_modal({
        patient_uuid: v.$route.params.patient_uuid,
      });
    },
  },
};
</script>

<style scoped>
.container {
  margin-top: 20px;
}
</style>
